import React, { useMemo } from 'react';

import { AnimatePresence } from 'framer-motion';

import { useAppSelector } from '@pkg/hooks';

import { TransferStatus } from '@app/client';
import { useEmojisStore } from '@app/store/zustand/emojis/useEmojisStore';

import { Sheet } from '../../Sheet';
import { YatTile } from '../../YatTile';

import './YatTransferSheet.scss';
import { CancelTransfer, InitiateTransfer, SenderCodes, TransferPending } from './steps';

export interface YatTransferSheetProps {
    onClose: () => void;
}

export function YatTransferSheet({ onClose }: YatTransferSheetProps) {
    const { currentEmoji, currentGeneration, currentRhythmScore } = useEmojisStore();
    const { transferData } = useAppSelector((state) => state.transfers);

    const currentStep = transferData[currentEmoji]?.status;

    const renderStep = useMemo(() => {
        switch (transferData[currentEmoji]?.status) {
            case TransferStatus.Default:
                return <InitiateTransfer eid={currentEmoji} />;
            case TransferStatus.Initiated:
                return <SenderCodes />;
            case TransferStatus.Pending:
                return <TransferPending eid={currentEmoji} />;
            case TransferStatus.CancelInitiated:
                return <CancelTransfer />;
            default:
                return <InitiateTransfer eid={currentEmoji} />;
        }
    }, [transferData, currentEmoji]);

    return (
        <Sheet backdrop onClose={onClose}>
            <Sheet.FixedCloseAction key="CloseAction" onAction={onClose} />

            <AnimatePresence mode="wait">
                <Sheet.Main key={`YatTransferSheet-Step-${currentStep}`}>
                    <Sheet.Layout>
                        <Sheet.Layout.Columns stretch>
                            <Sheet.Layout.Columns.Primary padded scrollable>
                                <div className="yat-transfer-sidebar">
                                    <YatTile
                                        yat={currentEmoji}
                                        generation={currentGeneration}
                                        rhythmScore={currentRhythmScore}
                                        showRhythmScore={false}
                                        glow={true}
                                        classes="yat-transfer-sidebar__yat"
                                    />

                                    {renderStep}
                                </div>
                            </Sheet.Layout.Columns.Primary>
                        </Sheet.Layout.Columns>
                    </Sheet.Layout>
                </Sheet.Main>
            </AnimatePresence>
        </Sheet>
    );
}
